<label class="radio-option">
  <input
    [attr.data-testid]="dataTestId"
    type="radio"
    [name]="name"
    [checked]="checked"
    [disabled]="disabled"
    (change)="onChange()"
  />
  <ng-content></ng-content>
</label>
